'use client';
import React, { useState } from 'react';

const suggestions = [
  { id: 'sug-01', text: 'Safe travels, whale friend.' },
  { id: 'sug-02', text: 'Rest well, little fish.' },
  { id: 'sug-03', text: 'The ocean loves you.' },
  { id: 'sug-04', text: 'Swim free, dear dolphin.' },
  { id: 'sug-05', text: 'You are safe here.' },
];

interface SentBlessing {
  id: string;
  text: string;
  time: string;
}

const initialBlessings: SentBlessing[] = [
  { id: 'sb-001', text: 'Safe travels, whale friend.', time: '04:58' },
  { id: 'sb-002', text: 'Rest well, little fish.', time: '04:51' },
  { id: 'sb-003', text: 'The ocean loves you.', time: '04:44' },
  { id: 'sb-004', text: 'Swim free, dear dolphin.', time: '04:37' },
];

export default function BlessingInput() {
  const [text, setText] = useState('');
  const [sent, setSent] = useState<SentBlessing[]>(initialBlessings);
  const [floating, setFloating] = useState<string | null>(null);

  const sendBlessing = (blessing: string) => {
    if (!blessing.trim()) return;
    const newBlessing: SentBlessing = {
      id: `sb-${sent.length + 1}`,
      text: blessing,
      time: '05:03',
    };
    setSent((prev) => [newBlessing, ...prev]);
    setFloating(blessing);
    setText('');
    setTimeout(() => setFloating(null), 3000);
  };

  return (
    <div className="bg-card/40 border border-border/50 rounded-2xl p-5 backdrop-blur-sm relative overflow-hidden">
      {/* Floating blessing animation */}
      {floating && (
        <div
          className="absolute left-1/2 bottom-16 -translate-x-1/2 px-4 py-2 rounded-full text-sm font-medium text-kid-blue bg-kid-ocean/30 border border-kid-ocean/40 pointer-events-none"
          style={{ animation: 'slideUp 0.4s ease-out, fadeIn 0.4s ease-out' }}
        >
          ✨ {floating}
        </div>
      )}

      <div className="flex items-center gap-2 mb-4">
        <span className="text-lg">✨</span>
        <div>
          <h2 className="text-sm font-semibold text-foreground">Ocean Blessings</h2>
          <p className="text-[10px] text-kid-blue/70">Send gentle words to ocean friends</p>
        </div>
        <span className="ml-auto text-[10px] text-muted-foreground">{sent.length} sent</span>
      </div>

      {/* Input */}
      <div className="mb-3">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Write a gentle blessing..."
          rows={2}
          className="w-full px-3 py-2 bg-muted/30 border border-border/50 rounded-xl text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-kid-blue/40 resize-none"
        />
        <button
          onClick={() => sendBlessing(text)}
          disabled={!text.trim()}
          className="mt-2 w-full py-2 rounded-xl bg-kid-ocean/30 border border-kid-blue/30 text-kid-blue text-xs font-bold hover:bg-kid-ocean/50 transition-all duration-150 active:scale-95 disabled:opacity-40"
        >
          Send Blessing ✨
        </button>
      </div>

      {/* Quick suggestions */}
      <div className="flex flex-wrap gap-1.5 mb-4">
        {suggestions.map((s) => (
          <button
            key={s.id}
            onClick={() => sendBlessing(s.text)}
            className="px-2.5 py-1 rounded-full bg-muted/30 border border-border/50 text-[10px] text-muted-foreground hover:text-kid-blue hover:border-kid-blue/30 transition-all duration-150"
          >
            {s.text}
          </button>
        ))}
      </div>

      {/* Sent blessings */}
      <div className="space-y-1.5 max-h-32 overflow-y-auto scrollbar-ocean">
        {sent.map((b) => (
          <div key={b.id} className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-kid-ocean/10 border border-kid-ocean/20">
            <span className="text-xs">✨</span>
            <span className="text-xs text-foreground/80 flex-1 italic">{b.text}</span>
            <span className="text-[10px] text-muted-foreground font-mono flex-shrink-0">{b.time}</span>
          </div>
        ))}
      </div>
    </div>
  );
}